<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <span>🌍</span>
            <span class="-mt-1 mr-1">👥</span>
            <span>Total number of expat and local students against program and campus</span>
        </h2>
        <div class="overflow-auto">
            <table class="min-w-full table-auto border border-gray-300 text-sm">
                <thead class="uppercase">
                    <!-- First header row -->
                    <tr class="bg-gray-100">
                        <th rowspan="2" class="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-800">
                            Program Name
                        </th>
                        <th v-for="campus in campuses" :key="campus" colspan="2"
                            class="border border-gray-300 px-4 py-3 text-center font-semibold text-gray-800 whitespace-nowrap">
                            {{ campus }}
                        </th>
                        <th rowspan="2"
                            class="border border-gray-300 px-4 py-3 text-center font-semibold text-gray-800">
                            Total
                        </th>
                    </tr>
                    <!-- Second header row -->
                    <tr class="bg-gray-50">
                        <template v-for="campus in campuses" :key="campus + '-sub'">
                            <th class="border border-gray-300 px-2 py-2 text-center font-medium text-gray-700">National
                            </th>
                            <th class="border border-gray-300 px-2 py-2 text-center font-medium text-gray-700">Expat
                            </th>
                        </template>
                    </tr>
                </thead>

                <tbody class="bg-white">
                    <tr v-for="(row, index) in tableRows" :key="index" class="hover:bg-gray-50 transition">
                        <td class="border border-gray-300 px-4 py-2 text-gray-800 font-medium">
                            {{ row.program_name }}
                        </td>
                        <template v-for="campus in campuses" :key="campus + '-data'">
                            <td class="border border-gray-300 px-2 py-2 text-center text-gray-700">
                                {{ (row.campuses[campus] && row.campuses[campus].national) || 0 }}
                            </td>
                            <td class="border border-gray-300 px-2 py-2 text-center text-gray-700">
                                {{ (row.campuses[campus] && row.campuses[campus].expat) || 0 }}
                            </td>
                        </template>
                        <td class="border border-gray-300 px-4 py-2 text-center font-semibold text-blue-700">
                            {{ row.total }}
                        </td>
                    </tr>
                </tbody>

                <tfoot class="bg-gray-100 text-gray-800 font-semibold uppercase">
                    <tr>
                        <td class="border border-gray-300 px-4 py-2">Total</td>
                        <template v-for="campus in campuses" :key="'footer-' + campus">
                            <td class="border border-gray-300 px-2 py-2 text-center">
                                {{ (footer.campuses[campus] && footer.campuses[campus].national) || 0 }}
                            </td>
                            <td class="border border-gray-300 px-2 py-2 text-center">
                                {{ (footer.campuses[campus] && footer.campuses[campus].expat) || 0 }}
                            </td>
                        </template>
                        <td class="border border-gray-300 px-4 py-2 text-center text-blue-700">
                            {{ footer.total }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "no-of-expat-and-local-against-program-campus",
    props: ["data"],
    data() {
        return {
            campuses: [],
            tableRows: [],
            footer: {
                campuses: {},
                total: 0,
            },
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (!newData || !Array.isArray(newData)) return;

                // 1. Get unique campuses
                const campuses = Array.from(
                    new Set(newData.map((item) => item.campus_code))
                );

                // 2. Group data by program_name
                const programMap = new Map();

                newData.forEach((item) => {
                    const key = item.program_name;
                    if (!programMap.has(key)) {
                        programMap.set(key, {
                            program_name: key,
                            campuses: {},
                            total: 0,
                        });
                    }

                    const entry = programMap.get(key);
                    entry.campuses[item.campus_code] = {
                        national: item.national_count,
                        expat: item.expat_count,
                    };
                    entry.total += item.national_count + item.expat_count;
                });

                const tableRows = Array.from(programMap.values());

                // 3. Compute footer totals
                const footer = {
                    campuses: {},
                    total: 0,
                };

                campuses.forEach((campus) => {
                    let national = 0;
                    let expat = 0;

                    tableRows.forEach((row) => {
                        const c = row.campuses[campus];
                        if (c) {
                            national += c.national || 0;
                            expat += c.expat || 0;
                        }
                    });

                    footer.campuses[campus] = { national, expat };
                    footer.total += national + expat;
                });

                // Set data
                this.campuses = campuses;
                this.tableRows = tableRows;
                this.footer = footer;
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>